import { Directive, inject } from "@angular/core";
import { Listbox } from "@openng/optimus-ui/listbox";
import { MultiSelect } from "@openng/optimus-ui/multiselect";
import { Select } from "@openng/optimus-ui/select";
import { MultiWordFilter } from "../../utils/misc/multi-word-filter";

@Directive({
    selector: "p-select[filter], p-multiSelect, p-listbox[filter]",
    standalone: false
})
export class DropdownMultiWordFilterDirective {

    listbox = inject(Listbox, { optional: true, self: true });
    multiSelect = inject(MultiSelect, { optional: true, self: true });
    select = inject(Select, { optional: true, self: true });

    constructor() {
        let dropdown = this.select ?? this.multiSelect ?? this.listbox;
        if (dropdown?.filterMatchMode == "contains") {
            dropdown.filterMatchMode = MultiWordFilter.matchMode;
        }
    }

}
